export default {
      id: "logo_checkers_color-usage",
      viewBox: "0 0 155 30",
      url: __webpack_public_path__ + "sprite.svg#logo_checkers_color",
      toString: function () {
        return this.url;
      }
    }